import { createStore } from '@stencil/store';
import { TripPlannerState } from '../types';
import { changeOverflowBody } from '../utils/ui';
import initParams from './initParams';

const { state, onChange } = createStore<TripPlannerState>({
  showModal: null,
});

onChange('showModal', newValue => {
  changeOverflowBody(newValue !== null, initParams.isApp);
  switch (newValue) {
    case 'EDIT_MODAL':
      if (typeof state.fields === 'undefined') {
        console.warn('EDIT_MODAL requires fields to be defined. Resetting showModal to null.');
        state.showModal = null;
      }
      break;

    case 'ITEM_DETAIL_MODAL':
      if (typeof state.item === 'undefined') {
        console.warn('ITEM_DETAIL_MODAL requires item to be defined. Resetting showModal to null.');
        state.showModal = null;
      }
      break;

    case 'ITINERARY_MAP_MODAL':
      if (typeof state.days === 'undefined') {
        console.warn('ITINERARY_MAP_MODAL requires days to be defined. Resetting showModal to null.');
        state.showModal = null;
      }
      break;

    default:
      break;
  }
});

export default state;
